/* =========================================================================
   Help page — wires the on-page CTAs to the Zendesk messaging widget.

   Only loaded by templates/page.help.liquid, so this never runs elsewhere.

   The buttons ship DISABLED in the markup and are enabled here once the
   widget is reachable. If Zendesk is blocked (ad blockers routinely eat
   static.zdassets.com) the buttons fall back to email rather than sitting
   dead — a "Start live chat" button that does nothing is worse than no
   button at all.
   ========================================================================= */
(function () {
  'use strict';

  var FALLBACK_EMAIL = 'help@americanflat.com';
  var POLL_MS = 150;
  var GIVE_UP_MS = 10000;

  function buttons() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-af-open-chat]')
    );
  }

  function enable() {
    buttons().forEach(function (b) { b.removeAttribute('disabled'); });
  }

  /* Zendesk unreachable: turn the CTAs into mail links in place. */
  function fallback() {
    buttons().forEach(function (b) {
      b.removeAttribute('disabled');
      b.setAttribute('data-af-chat-fallback', '');
      // Keep the arrow, swap the label text node only.
      var arrow = b.querySelector('.af-help-btn__arrow');
      b.textContent = 'Email us';
      if (arrow) b.appendChild(arrow);
      b.setAttribute('aria-label', 'Email us at ' + FALLBACK_EMAIL);
    });
  }

  function openMessenger() {
    try {
      // zE is a queueing stub until the widget finishes booting, so a call
      // made this early is held and replayed rather than lost.
      window.zE('messenger', 'open');
      return true;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-af-open-chat]');
    if (!btn) return;
    evt.preventDefault();

    if (btn.hasAttribute('data-af-chat-fallback')) {
      window.location.href = 'mailto:' + FALLBACK_EMAIL;
      return;
    }
    if (!openMessenger()) fallback();
  });

  /* Wait for the snippet to define zE. */
  var waited = 0;
  var timer = setInterval(function () {
    if (typeof window.zE === 'function') {
      clearInterval(timer);
      enable();
      return;
    }
    waited += POLL_MS;
    if (waited >= GIVE_UP_MS) {
      clearInterval(timer);
      fallback();
    }
  }, POLL_MS);
})();
